import { useInViewSSR } from "@design-system/hooks";
import { ManageCookiesButton } from "@modules/cookies/components";
import { trans } from "@mongez/localization";
import { motion } from "framer-motion";

export function Copyright() {
  const currentYear = new Date().getFullYear();

  const { ref: copyrightRef, isInView } = useInViewSSR<HTMLDivElement>({
    once: true,
  });

  return (
    <motion.div
      ref={copyrightRef}
      initial={{ y: "-700%" }}
      animate={isInView && { y: 0 }}
      transition={{ duration: 1.2 }}
      className="flex items-center justify-center gap-4 py-10 max-lg:text-sm max-md:flex-col"
    >
      <p>
        {trans("copyright", {
          date: currentYear,
        })}
      </p>

      <p>
        <span>{trans("craftedBy")} </span>
        <a
          className="font-medium text-dusty-orange underline"
          href="https://crafted-internet.com/"
          target="_blank"
        >
          Crafted Internet
        </a>
        <span className="ltr:inline-block rtl:hidden">
          , {trans("craftedWithCare")}
        </span>
      </p>
      <ManageCookiesButton />
    </motion.div>
  );
}
